import React from 'react';
import Reflux from 'reflux';
import GongqiFormItem from './GongqiFormItem';
import FormItemUtil from '../utils/FormItemUtil';
import StringUtil from '../utils/StringUtil';
import Warning from '../utils/Warn';
import {GroupCurrentRecordChangedStore} from '../stores/RecordsStore';
import {CmdWriteControlStore,CmdUpdateControlAllowEditStore} from '../stores/CmdTypeStore';
import {FocusSetStore} from '../stores/FocusStore';
import Fade from'../utils/Fade';
import Command from '../remote/Command';
import ServiceHelper from '../remote/ServiceHelper';
import Gongqi_ProgressBar from '../websocket/Gongqi_ProgressBar';
import FormItemImageDialog from './FormItemImageDialog';
import ReactDOM from 'react-dom';
require('../styles/FormItemImageStyle.css');

class FormItemImage extends GongqiFormItem
{

	constructor(props) {
		super(props);
		this.record = null;
		this.origRecord = null;
		this.imgPathURL = null;
		this.registerStores();
		this.props.contextMenuData.items.push(
			 {label:'另存为',icon:'',action:this.saveAs.bind(this)},
			 {label:'上传',icon:'',action:this.chooseImg.bind(this)},
			 {label:'删除',icon:'',action:this.deleteImg.bind(this)}
		);
		this.props.contextMenuData.beforeMenuShow = this.beforeContextMenuShow.bind(this);
		this.resourceURL=window.parent.window.userInfos.resourceURL;
		this.serviceURL=window.parent.window.userInfos.serviceURL;
		this.conditions={
			 	requestUrl:this.serviceURL + "/FileUpLoad",
                fileFilters:'',
                sizeLimit:500000000000,
                sizeMin:0,
                heightMin:0,
                height:0,
                width:0,
                widthMin:0,
                compress:true,
                _selected:null
		};
		this.imgUrl='';
		this.deletedImgArr = [];
		this.unsubscribeCmdWriteControlStore = CmdWriteControlStore.listen(this.onCmdWriteControlStore.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeCmdWriteControlStore();
	}

	onCmdWriteControlStore(arg,moduleInstanceId)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId)
		{
			var value = arg[this.props.xml.name];
			value = this.resourceURL + "/" + value;
			this.displayImage(value);
		}
	}

	//只支持谷歌浏览器
	saveAsUrl(Url,filename){
		var blob=new Blob([''], {type:'application/octet-stream'});
	    var url = URL.createObjectURL(blob);
	    var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
	    a.href = Url;
	    a.download = filename;
	    var e = document.createEvent('MouseEvents');
	    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	    a.dispatchEvent(e);
	    URL.revokeObjectURL(url);
	}

    saveText(t,filename){
		var mime='text/plain';
		saveAs(('data:'+mime+';charset=utf-8;base64,' + Base64.encode(t)),filename);
	}

	saveAs()
	{
		if(this.imgPathURL == null)
			return;
		if(this.props.multiple == true)
		{
			let imgList = this.state.imageList;
			if(!imgList || imgList.length == 0)
			{
				return;
			}
			let imgName = imgList[imgList.length-1];
			let imgPath = this.state.dataurl+"/"+imgName;
			this.saveAsUrl(imgPath,imgName);
		}
		else
		{
			this.saveAsUrl(this.imgPathURL,"2.jpg")
		}

		return;
        //如果隐藏IFRAME不存在，则添加
        if (!document.getElementById("IframeReportImg"))
        {
        	window.doSaveAsIMG = this.doSaveAsIMG.bind(this);
        	$('<iframe style="display:none;" id="IframeReportImg" name="IframeReportImg" onload="doSaveAsIMG();" width="0" height="0" src="about:blank"></iframe>').appendTo("body");

        }

        if (document.all.IframeReportImg.src != this.imgPathURL) {
            //加载图片
            document.all.IframeReportImg.src = this.imgPathURL;
        }
        else {
            //图片直接另存为
            this.doSaveAsIMG();
        }

	}

	onDelete(event)
	{
	   var x = $(this.uploaderContainer).find('.viewer-container').hasClass("viewer-in");
		if (x) {
			//event.stopPropagation();
			//alert("1");
			if (event.nativeEvent)
			{
				event.nativeEvent.stopImmediatePropagation();
				return;
			}


		}

	  if(!(event.keyCode==86&&event.ctrlKey))
	  {
	  	event.preventDefault();
        return false;
	  }
	  /*alert(event.keyCode);
	  if(event.keyCode == 46||event.keyCode == 8)
	  {
	  	//del&backspace
		event.preventDefault();
        return false;
      }*/
	}

	doSaveAsIMG() {
        if (document.all.IframeReportImg.src != "about:blank")
            document.getElementById("IframeReportImg").contentDocument.execCommand("SaveAs");
    }

	registerStores()
	{
		this.unsubscribeGroupCurrentRecordChangedStore = GroupCurrentRecordChangedStore.listen(this.onCurrentRecordChanged.bind(this));
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias)
	{
		if(this.props.groupAlias)
		{
			if(this.props.groupAlias == groupAlias)
			{
				this.record = currentRecord;
				this.origRecord = Object.assign({},currentRecord);

				let _url = this.props.url;
				let sourceName = this.url2resName(_url);


				// let resourceURL=parent.window.userInfos.resourceURL;
				let resourceURL=this.resourceURL;
				if(sourceName.startsWith("@tmp")){
					resourceURL = this.serviceURL+"/tmp"
				}
				this.sourceName=sourceName;
				this.uploadPath = sourceName;
				let finalUrl=resourceURL+"/"+sourceName;
				this.imgPathURL = finalUrl;
				//$(this.uploadImg).attr("src",'../images/imgError.jpg').attr('alt','暂无图片');
				this.displayImage(finalUrl);

				// var reader = new FileReader();
				// let that = this;
				// reader.onload = function(e){that.displayImage(e.target.result)};
				// if(window.testblob)
				// 	reader.readAsDataURL(window.testblob);
			}
		}
	}

	/*isUrlExist(_url)
	{
		if(this.xmlhttp == null || this.xmlhttp == undefined)
		{
			this.xmlhttp = new XMLHttpRequest();
			//this.xmlhttp.onreadystatechange=this.uploadStateChangeHandler.bind(this);
		}
		this.xmlhttp.open("GET", _url,true);
		this.xmlhttp.send();
		return this.xmlhttp.status == 0;
	}*/

	//应该首先请求后台 得到返回结果后做相应处理 如果成功 则返回一个url 否则 返回自定义错误信息
	displayImage(dataurl)
	{
		let domain = window.domain;
		var dataurlbak = dataurl;
		try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
		{
		  if(!domain && window.parent && window.parent.window)
			  domain = window.parent.window.didomain;
		  if(domain)
		  {
			var loginToken = window.loginToken;
			var loginDataArea = window.loginDataArea;
			if(window.parent && window.parent.window)
			{
				if(!loginToken)loginToken = window.parent.window.loginToken;
				if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
			}
			if(!loginToken)
			{
				if(dataurl.indexOf("?") != -1)
				{
					dataurl+=("&token="+localStorage.getItem("userToken"));
				}
				else
				{
					dataurl+=("?token="+localStorage.getItem("userToken"));
				}
			}
			
		  }

		}
		catch(e)
		{

		}

		if(this.props.multiple)
		{
			let _urlBase = "";
			if(window.urlBase)
				_urlBase = window.urlBase;
			let _headers = {};
			if(window.didomain)
			{
				var loginToken = window.loginToken;
	  			var loginDataArea = window.loginDataArea;
				if(window.parent && window.parent.window)
				{
					if(!loginToken)loginToken = window.parent.window.loginToken;
					if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
				}
				if(!loginToken)
				{
					let _token = localStorage.getItem("userToken");
					if(_token)
						_headers.token = _token;
				}
				
			}
			$.ajax({
				type:'post',
				url:this.serviceURL+"/GongqiERP/resource/list?path="+this.uploadPath,
				dataType:"json",
				headers: _headers,
				//暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
				xhrFields:{withCredentials:true},

				success:this.getImageList.bind(this,dataurl),
				error:this.getImageListError.bind(this)
			});
		}
		else
		{
			$(this.uploadImg).css("opacity","0");
			$(this.noImageContainer).css("display","none");
			//let finalUrl=resourceURL+"/"+sourceName;
			if(this.deletedImgArr && this.deletedImgArr.indexOf(dataurlbak) == -1)
			{
				$(this.uploadImg).attr('src',dataurl).show();//+=('?t='+new Date()));
			}
			else
			{
				let now = new Date();
				$(this.uploadImg).attr('src',dataurl+('?t='+now.getTime())).show();
			}
			
		}
	}

	getImageList(dataurl,result)
	{
		//alert(JSON.stringify(data));
		let imageList = result.data;
		this.setState({imageList:imageList,dataurl:dataurl});
	}

	getImageListError(data)
	{

	}

	componentDidUpdate()
	{
		if(this.props.multiple)
		{
			$(this.uploaderContainer).viewer('destroy');
			$(this.uploaderContainer).viewer({
				fullscreen:false
			});
			if(this.state.imageList && this.state.imageList.length>0)
				$(this.noImageContainer).css("display","none");

			/*$(this.uploadImg).css("opacity","0");
			$(this.noImageContainer).css("display","none");
			$(this.uploadImg).attr('src',dataurl).show();//+=('?t='+new Date()));*/
		}
	}

	componentDidMount()
	{
		$(this.uploaderContainer).contextPopup(this.props.contextMenuData);
		if(!this.props.multiple)
		{
			$(this.uploaderContainer).viewer({
				url: 'data-original',
				navbar:false,
				fullscreen:false
			});
		}

		var suffix=this.props.suffix;
		var accept="";
		if(suffix!=""){
			var suffixArray=suffix.split(",");
			for(var i in suffixArray){
				if(i==suffixArray.length-1)
					accept+="image/"+suffixArray[i];
				else
					accept+="image/"+suffixArray[i]+",";
			}
			$(this.uploaderInput).attr("accept",accept);
		}
		if(this.props.initRecord)
		{
			this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
		}
		else if(!this.props.groupAlias)
		{
			let _url = this.props.url;
			let sourceName = this.url2resName(_url);
			let resourceURL=this.resourceURL;
			this.sourceName=sourceName;
			this.uploadPath = sourceName;
			let finalUrl=resourceURL+"/"+sourceName;
			this.imgPathURL = finalUrl;
			this.displayImage(finalUrl);
		}
	}

	displayNoneImage()
	{

	}

	url2resName(url)
	{
		var temp = "";
		var flag = false;
		var sourceName = "";

		if(true)
		{
			var array = url.split("");
			for(var i in array)
			{
				var s = array[i];
				if(s == "(")
				{
					temp += s ;
					flag = true ;
					continue;
				}

				if(s == ")")
				{
					temp = temp.substr(1);
					var group = this.props.group;
					if(group == null)
						return "";
					var index = 0;

					while(temp.charAt(index) == ".")
					{
						if(index == 0)
						{
							index ++ ;
							continue;
						}
						if(group == null)
						{
							alert("对于Image控件 点号与实际的FormDataSource不对应");
							return "";
						}
						group = group.linkGroup;

						index ++;
					}

					//temp = temp.substr(index);
					temp = StringUtil.convertToEachFirstLowerCase(temp.substr(index));
					temp = StringUtil.convertToFirstUpperCase(temp);
					if(temp.indexOf(".") == -1)
					{

					}
					else
					{
						var a = temp.split(".");

						if(group == null)
						{
							alert("对于Image控件 点号与实际的FormDataSource不对应");
							return "";
						}
						var obj  = group.currentRecord;
						if(obj == null)
							return "";

						let _value = obj[temp];

						if(_value != null)
							sourceName += _value;
					}
					temp = "";
					flag = false;
					continue ;
				}

				if(flag)
				{
					temp+=s ;
					continue ;
				}

				sourceName += s ;
			}

		}
		else
		{
			sourceName = url;
		}

		return sourceName;
	}


	imageLoaderOnLoadHandler()
	{
		// var img=e.target.result;
       	// $(this.uploaderContainer).removeClass("imageUploaderContainer");
       	// $(this.uploaderContainer).css("background-image",'url('+this.imgUrl+')');
		   // $(this.uploaderContainer).css("background-repeat","round");

		if(this.props.multiple == true)
		{
			let _url = this.props.url;
			let sourceName = this.url2resName(_url);
			let finalUrl=this.resourceURL+"/"+sourceName;
			this.displayImage(finalUrl);
			return;
		}

		if(this.imgUrl=='')
		{
			//$(this.uploadImg).attr("src",'../images/imgError.jpg').attr('alt','暂无图片');
			if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
				$(this.noImageContainer).css("display","flex");
			else
				$(this.noImageContainer).css("display","none");
			$(this.uploadImg).hide();
       		this.sourceName = "";
		}
		else
		{
			$(this.noImageContainer).css("display","none");
       		$(this.uploadImg).attr('src',this.imgUrl).attr('alt','').show();
       	}

	}

	chooseImg()
	{
		$(this.uploaderInput).attr('accept',this.conditions.fileFilters);
		$(this.uploaderInput).click();
	}

	deleteImgAfterSelected(imgNames)
	{
    for(var i=0;i<imgNames.length;i++){
      var command = Command.createService( "gongqi.erp.gotmodel.services.AttachmentService", "deleteFile", "boolean");
      command.appendArg(this.sourceName+"/"+ imgNames[i]);
      if(i == imgNames.length-1 ){
        ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_result_deleteImageHandler.bind(this)});
      }else{
        ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_result_deleteImageHandlers.bind(this)});
      }
    }
	}
  //循环删除 防止多个Fade.show()
  rpc_result_deleteImageHandlers(data)
	{
		if(data.result)
		{

			if(this.props.multiple == true)
			{
				this.displayImage(this.state.dataurl);
			}
			else
			{
				this.imgError();
			}
		}else
		{
			Warning.show({text:"删除失败"});
		}
	}

	deleteImg()
	{
		if(this.props.multiple == true && this.state.imageList && this.state.imageList.length>1)
		{
			let imgPath = this.state.dataurl+"/";
			let le = this.state.imageList.length
			ReactDOM.render(<FormItemImageDialog imgPath = {imgPath} imgName = {this.sourceName} imgNum = {le} imgs = {this.state.imageList} deleteImgs = {this.deleteImgAfterSelected.bind(this)} />, this.FormItemImage_Dialog);
		}
		else
		{
			var command = Command.createService( "gongqi.erp.gotmodel.services.AttachmentService", "deleteFile", "boolean");
			if(!this.props.multiple)
			{
				command.appendArg(this.sourceName);
			}
			else
			{
				if(this.state.imageList && this.state.imageList.length>0)
				{
					let lastItem = this.state.imageList[this.state.imageList.length-1];
					//alert(lastItem);
					command.appendArg(this.sourceName+"/"+lastItem);
				}
				else
				{
					command.appendArg(this.sourceName);
				}
			}
			ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_result_deleteImageHandler.bind(this)});
		}

	}

	rpc_result_deleteImageHandler(data)
	{
		if(data.result)
		{

			if(this.props.multiple == true)
			{
				this.displayImage(this.state.dataurl);
			}
			else
			{
				this.deletedImgArr.push(this.resourceURL+"/"+this.sourceName);
				this.imgError();
			}

			Fade.show({text:"删除成功",state:"info"});

		}else
		{
			Warning.show({text:"删除失败"});
		}
	}


	upLoaderChangeHandler(e)
	{
  		var uploadFiles = e.target.files || e.dataTransfer.files;
        var uploadFile = uploadFiles[0];
        //this.checkUploadFile(uploadFile);
        var type=uploadFile.type;
        var _selected=this.conditions._selected;
        var fileName;
        var file;
        var selected=this.selected.bind(this);
        if(_selected!=null){
            fileName=selected();
            file= new File([uploadFile],fileName,{type:type});
        }else{
            file=uploadFile;
        }
        var imgHeight=this.conditions.height;
        var imgWidth=this.conditions.width;
        var heightMin=this.conditions.heightMin;
        var widthMin=this.conditions.widthMin;
        var sizeLimit=this.conditions.sizeLimit;
        var sizeMin=this.conditions.sizeMin;
        var reader = new FileReader();
        var fileFilters=this.conditions.fileFilters;
        var fileSize=file.size;
        var uploadFile=this.uploadFile.bind(this);
        this.imgUrl='';
        var that=this;
        reader.readAsDataURL(file);
        var data;
        reader.onloadend = function (e) {
           	data=e.target.result;
           	if(type.indexOf('image')>-1){
        	 	that.imgUrl=data;
       	 	}
        }




        if(fileFilters.indexOf('image')>-1){
            var image = new Image();
            image.src= data;
           	image.onload=function(){
                var width = image.width;
                var height = image.height;
                if((imgHeight!=0&&height>imgHeight)||(heightMin!=0&&height<heightMin)){
                	Warning.show({text:"图片高度不符合要求！"});
                }else if((imgWidth!=0&&width>imgWidth)||(widthMin!=0&&width<widthMin)){
                	Warning.show({text:"图片宽度不符合要求！"});
                }else if(sizeLimit!=0&&fileSize>sizeLimit){
                	Warning.show({text:"超过上传文件最大限制：" + (sizeLimit/1024).toFixed(1) + "K"});
                }else if(sizeMin!=0&&fileSize<sizeMin){
                	Warning.show({text:'上传文件不得小于'+(sizeMin/1024).toFixed(1)+'K'});
                }else{
                	uploadFile(file);
                }
            };
        }else{
           	if(sizeLimit!=0&&fileSize>sizeLimit){
                Warning.show({text:"超过上传文件最大限制：" + (sizeLimit/1024).toFixed(1) + "K"});
            }else if(sizeMin!=0&&fileSize<sizeMin){
                Warning.show({text:'上传文件不得小于'+(sizeMin/1024).toFixed(1)+'K'});
            }else{
                this.uploadFile(file);
            }
        }
    	$(this.uploaderInput).val("");
	}

	selected(){

	}

	onDragDrop(e)
	{
		e.stopPropagation();
        //阻止浏览器默认打开文件的操作
        e.preventDefault();
		let files = e.dataTransfer.files;
		let file = files?files[0]:null;
		if(file)
			this.checkUploadFile(file);
	}

	checkUploadFile(uploadFile,from)
	{
		if(this.props.groupAlias && this.record)
		{
			let recVersion = this.record[this.props.groupAlias+".recVersion"];
			if(recVersion == -1 || recVersion == "-1")
			{
				Warning.show({text:"该记录从未保存过，因此无法基于该记录上传图片"});
				return;
			}
		}

		let _enable = this.props.control.getProperty_AllowEdit_Final();
		if(_enable == false)
		{
			Warning.show({text:"当前状态下图片不可编辑"});
			return;
		}
		var type=uploadFile.type;
        var _selected=this.conditions._selected;
        var fileName;
        var file;
        var selected=this.selected.bind(this);
        if(_selected!=null){
            fileName=selected();
            file= new File([uploadFile],fileName,{type:type});
        }else{
			file=uploadFile;
			if(from == "paste")
			{
				file= new File([uploadFile],file.lastModified+file.name,{type:type});
				//file.name = file.lastModified+file.name;
			}
        }
        var imgHeight=this.conditions.height;
        var imgWidth=this.conditions.width;
        var heightMin=this.conditions.heightMin;
        var widthMin=this.conditions.widthMin;
        var sizeLimit=this.conditions.sizeLimit;
        var sizeMin=this.conditions.sizeMin;
        var reader = new FileReader();
        var fileFilters=this.conditions.fileFilters;
        var fileSize=file.size;
        var uploadFile=this.uploadFile.bind(this);
        this.imgUrl='';
        var that=this;
        reader.readAsDataURL(file);
        var data;
        reader.onloadend = function (e) {
           	data=e.target.result;
           	if(type.indexOf('image')>-1){
        	 	that.imgUrl=data;
       	 	}
        }




        if(fileFilters.indexOf('image')>-1){
            var image = new Image();
            image.src= data;
           	image.onload=function(){
                var width = image.width;
                var height = image.height;
                if((imgHeight!=0&&height>imgHeight)||(heightMin!=0&&height<heightMin)){
                	Warning.show({text:"图片高度不符合要求！"});
                }else if((imgWidth!=0&&width>imgWidth)||(widthMin!=0&&width<widthMin)){
                	Warning.show({text:"图片宽度不符合要求！"});
                }else if(sizeLimit!=0&&fileSize>sizeLimit){
                	Warning.show({text:"超过上传文件最大限制：" + (sizeLimit/1024).toFixed(1) + "K"});
                }else if(sizeMin!=0&&fileSize<sizeMin){
                	Warning.show({text:'上传文件不得小于'+(sizeMin/1024).toFixed(1)+'K'});
                }else{
                	uploadFile(file);
                }
            };
        }else{
           	if(sizeLimit!=0&&fileSize>sizeLimit){
                Warning.show({text:"超过上传文件最大限制：" + (sizeLimit/1024).toFixed(1) + "K"});
            }else if(sizeMin!=0&&fileSize<sizeMin){
                Warning.show({text:'上传文件不得小于'+(sizeMin/1024).toFixed(1)+'K'});
            }else{
                this.uploadFile(file);
            }
        }
    	$(this.uploaderInput).val("");
	}

	uploadFile(file)
	{
		var _path = this.uploadPath;
		if(this.props.multiple)
			_path+=("/"+file.name);
		var serviceURL=this.conditions.requestUrl+"?path="+_path+"&img=true";
        var oMyForm = new FormData();
        oMyForm.append("file", file);
        this.client=new XMLHttpRequest();
        /*var progressBar=$('<progress></progress>').css({'width':'15em','height':'1.2em'}).html('您的浏览器不支持progress元素');
        var that=this;
        var progressBtn=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
        var progressDiv=$('<div></div>').css({'position':'absolute','top':'40%','left':'40%'}).append(progressBar).append(progressBtn);
        var percentageDiv=$('<span></span>');
        var time=$("<span></span>");
        var percentDiv=$('<div></div>').css({'position':'absolute','top':'41%','left':'40%','font-size':'0.8em'}).append(percentageDiv).append(time);
        var progressBorder=$("<div></div>").append(progressDiv).append(percentDiv).css('display','none').attr('id','progressBorder');
		$('body').append(progressBorder);*/
		var progressArg = {modal:"modalSelf",title:"正在上传图片,请稍后...",total:1,loaded:1,closeable:false,text:""};
		var progressBar = Gongqi_ProgressBar.show(progressArg,window);

        this.client.upload.onprogress = function(pe) {
        	let updatedState = {};
	        if(pe.lengthComputable) {
	        	/*progressBorder.css('display','block');
	         	progressBar.attr('max',pe.total);
	        	progressBar.attr('value',pe.loaded);
				 percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");*/
				 updatedState.total = pe.total;
				 updatedState.loaded = pe.loaded;
				 updatedState.text = Math.round(pe.loaded / pe.total * 100) + "%";
				 //progressBar.setState({total:pe.total,loaded:pe.loaded,text:Math.round(pe.loaded / pe.total * 100) + "%"});
	        }
	        var nt = new Date().getTime();//获取当前时间
	        var pertime = (nt-this.ot)/1000; //计算出上次调用该方法时到现在的时间差，单位为s
	        this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
	        var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b
	        this.oloaded = pe.loaded;//重新赋值已上传文件大小，用以下次计算

	        //上传速度计算
	        var speed = perload/pertime;//单位b/s
	        var bspeed = speed;
	        var units = 'b/s';//单位名称
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'k/s';
	        }
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'M/s';
	        }
	        speed = speed.toFixed(1);
                        //剩余时间
        	var resttime = ((pe.total-pe.loaded)/bspeed).toFixed(1);

	        var timeContent=' '+speed+units+' 剩余时间:'+resttime+'s';
			//time.html(timeContent);
			updatedState.text+=timeContent;
			progressBar.setState(updatedState);
		}
		this.client.upload.onloadstart = function(){//上传开始执行方法
			this.ot = new Date().getTime();   //设置上传开始时间
			this.oloaded = 0;//设置上传开始时，以上传的文件大小为0
		};
		this.client.onreadystatechange=this.uploadStateChangeHandler.bind(this);

		this.client.open("POST", serviceURL,true);//+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
		this.client.withCredentials = true;

		this.client.onloadend = function(pe) {
				// document.getElementById('progressDiv').style.display='none';
			//$('#progressBorder').remove();
			progressBar.closeHandler();
		}
		this.client.send(oMyForm);

	}

	uploadStateChangeHandler()
	{
		var that=this;
		if (this.client.readyState==4)
	    {// 4 = "loaded"
	  		if (this.client.status==200)
	    	{
	    		var options={
	    			state:'success',
	    			text:'上传成功！'
	    		}
	    		Fade.show(options);
	    		this.imageLoaderOnLoadHandler()
	    	}
		  	else
		    {
		    	var options={
		    		state:'error',
	    			text:'上传失败！'
	    		}
	    		Fade.show(options);
		    }
	  	}
	}

	imgError(){
		//1.要获取getProperty_FailureImage 如果这个有 就用这个
		if(this.props.failureImage)
		{
			let newSrc = "customdev/"+this.props.failureImage;
			let origSrc = $(this.uploadImg).attr("src");
			if(newSrc != origSrc)
			{
				$(this.noImageContainer).css("display","none");
				$(this.uploadImg).attr("src",newSrc).show();
			}
			else
			{
				if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
					$(this.noImageContainer).css("display","flex");
				else
					$(this.noImageContainer).css("display","none");
				$(this.uploadImg).hide();
			}
			//$(this.uploadImg).attr("src",'../customdev/images/imgError.png').attr('alt','暂无图片');
		}
		else
		{
			if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
				$(this.noImageContainer).css("display","flex");
			else
				$(this.noImageContainer).css("display","none");
			$(this.uploadImg).hide();
			//$(this.uploadImg).attr("src",'../customdev/images/imgError.png').attr('alt','暂无图片');
		}
		this.sourceName = "";
		$(this.uploadImg).css("opacity","1");
	}


	cancelUpload(){
		this.client.abort();
	}

	beforeContextMenuShow(items)
	{
		let _enable = this.props.control.getProperty_AllowEdit_Final();
		let delItem = null;let upLoadItem = null;
		for(let i = 0;i<items.length;i++)
		{
			let item = items[i];
			if(!item)continue;
			if(item.label == "上传")
				upLoadItem = item;
			else if(item.label == "删除")
				delItem = item;
		}

		if(upLoadItem)upLoadItem.enable = _enable;
		if(delItem)delItem.enable = (this.sourceName==""||this.sourceName==null)?false:_enable;
	}

	uploadFromClipboardHandler(event)
	{
	    var clipboardData = event.clipboardData,i = 0,items, item, types;

	    if( clipboardData )
	    {
	      items = clipboardData.items;
	      if( !items ){
	        return;
	      }
	      item = items[0];
	      // 保存在剪贴板中的数据类型
	      types = clipboardData.types || [];
	      for( ; i < types.length; i++ ){
	        if( types[i] === 'Files' ){
	          item = items[i];
	          break;
	        }
	      }
	      // 判断是否为图片数据
	      if( item && item.kind === 'file' && item.type.match(/^image\//i) )
	      {
	        this.imgReader( item , "paste");
	      }
	      else
	      {
	      	event.preventDefault();
	      }
	    }
	}

	imgReader( item , from)
	{
	    var blob = item.getAsFile();
	    this.checkUploadFile(blob,from);
	      /*reader = new FileReader();
	    // 读取文件后将其显示在网页中
	    reader.onload = function( e ){
	      var img = new Image();

	      img.src = e.target.result;
	      document.body.appendChild( img );
	    };
	    // 读取文件
	    reader.readAsDataURL( blob );*/
	};

	imgLoaded(e)
	{
		if(!e.target)
			return;
		let outterWidth = $(this.outterDiv).width();
		let outterHeight = $(this.outterDiv).height();
		let dv = 0;let rate = 0;let tmp = 0;
		//8为padding+margin * 2
		if(e.target.width > (outterWidth-8))
		{
			//rate = e.target.height / e.target.width;
			//dv = e.target.width - (outterWidth - 8);
			e.target.width = outterWidth - 8;
			//e.target.height -= (dv*rate);
		}
		else if(e.target.height > (outterHeight-8))
		{
			//rate = e.target.width / e.target.height;
			//dv = e.target.height - (outterHeight - 8);
			e.target.height = outterHeight - 8;
			//tmp = Math.ceil(e.target.width-(dv*rate));
			//e.target.width = tmp;
		}
		$(this.uploadImg).css("opacity","1");
		//e.target.width = 162;
	}

	getImageRenderList()
	{
		let layoutMode = this.props.control.getProperty_LayoutMode();
		let imageStyle = {alignSelf:'strech',maxWidth:'100%',maxHeight:'100%'};
		if(layoutMode == "Scale")
		{
			imageStyle.height = imageStyle.width = "100%";
		}
		if(!this.props.multiple)
			return <img className="uploadImg" style={imageStyle} ref={node => this.uploadImg = node} onError={this.imgError.bind(this)} onLoad={this.imgLoaded.bind(this)}/>;

		let imgList = this.state.imageList;
		if(!imgList || imgList.length == 0)
		{
			return <img className="uploadImg" src={this.state.dataurl} style={imageStyle} ref={node => this.uploadImg = node} onError={this.imgError.bind(this)} onLoad={this.imgLoaded.bind(this)}/>;
		}
		let renderList = [];

		for(let i = 0;i<imgList.length;i++)
		{
			let imgPath = this.state.dataurl+"/"+imgList[i];
			if(this.props.multiple){
				if(window.parent.didomain){
					if(this.state.dataurl.indexOf("?")!=-1){
						imgPath = this.state.dataurl.substr(0,this.state.dataurl.indexOf("?"))+"/"+imgList[i]+this.state.dataurl.substr(this.state.dataurl.indexOf("?"));
					}
				}
			}
			if(i == imgList.length-1)
			{
				let imageStyle2 = {alignSelf:'strech',maxWidth:'100%',maxHeight:'100%'};
				renderList.push(<img src={imgPath} key={i} className="uploadImg" style={imageStyle2} ref={node => this.uploadImg = node}
								 onError={this.imgError.bind(this)} onLoad={this.imgLoaded.bind(this)}/>);
			}
			else
			{
				let imageStyle2 = {alignSelf:'strech',maxWidth:'100%',maxHeight:'100%',display:'none'};
				renderList.push(<img src={imgPath} key={i} className="uploadImg" style={imageStyle2}/>);
			}

		}
		return renderList;

	}

	getPromptDiv()
	{
		let _enable = this.props.control.getProperty_AllowEdit_Final();
		if(_enable)
		{
			return <div style={{fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#333333',letterSpacing:0,textAlign:'center',marginTop:'5px'}}>
				拖拽上传 或 粘贴
			</div>;
		}
		return null;
	}

	//contenteditable={true} onkeyDown={this.onDelete.bind(this)}
	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		_style.display = 'flex';_style.flexDirection = 'column';
		//alert(JSON.stringify(_style));
		//不一定固定居中 Scale是固定居中 Clip Repeat Fit
		let innerStyle = {};
		//innerStyle["border"] = "1px solid #uploadD9D9D9";
		innerStyle["position"] = "relative";
		innerStyle["margin"] = "3px";
		innerStyle["display"]="flex";
		innerStyle["alignItems"]="center";
		innerStyle["flexDirection"]="row";
		innerStyle["justifyContent"]="center";
		innerStyle["flexGrow"] = 100;
		innerStyle["overflow"] = "auto";
		innerStyle["cursor"] = "pointer";
		innerStyle["color"] = "white";//为了在编辑时不显示光标
		/*innerStyle["background"] = "#FAFAFA";
		innerStyle["border"] = "1px dashed #D9D9D9";
		innerStyle["borderRadius"] = "3px";*/
		innerStyle["padding"] = "10px";
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";


		let imgList = this.getImageRenderList();
		let cornerFlag = null;
		let outerClassName = "FormItemImageContainer";
		if(imgList.length>1)
		{
			outerClassName+=" FormItemImageMutiple";
			cornerFlag =
				<div style={{position:'absolute',right:'12px',zIndex:1,bottom:'9px',fontSize:'10px',display:'flex'}}>
						<i className="fa fa-paperclip" style={{marginTop:'2px',fontSize:'13px',transform:'rotate(45deg)'}}></i>
						<div style={{marginLeft:'3px',fontSize:'14px',fontWeight:'bold'}}>{imgList.length}</div>
				</div>;
		}

		//let promptDiv = this.getPromptDiv();

		return	<div className={outerClassName} style={_style} ref={node=>this.outterDiv=node} id={this.props.xml.name} onDrop={this.onDragDrop.bind(this)}>
					{cornerFlag}
					<input type="file" accept="image/jpg,image/jpeg,image/png,image/gif" multiple={false}  style={{display:'none'}} ref={node => this.uploaderInput = node} onChange={this.upLoaderChangeHandler.bind(this)}/>
					<div style={innerStyle} className="FormItemImage"  ref={node => this.uploaderContainer = node} contentEditable={true} onPaste={this.uploadFromClipboardHandler.bind(this)}>
						{imgList}

						<div ref={node=>this.noImageContainer=node} style={{display:'none',flexDirection:'column',alignItems:'center'}}>
							<i className="fa fa-picture-o" style={{color:'#40A9FF',fontSize:'32px'}}></i>
							<div style={{fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#333333',letterSpacing:0,textAlign:'center',marginTop:'5px'}}>
								拖拽上传 或 粘贴
							</div>;
						</div>

        			</div>

              <div  ref={node=>this.FormItemImage_Dialog=node}></div>
        		</div>
	}
};

FormItemImage.defaultProps = {
};

export default FormItemImage;



// WEBPACK FOOTER //
// ./src/formItem/FormItemImage.js